import React, { useState } from 'react';
import PropTypes from 'prop-types';

const FILE_UPLOAD_CONFIG = {
  accept: ".jpg,.png,.pdf,.doc,.docx",
  maxSize: "10MB",
  supportedFormats: "JPG, PNG, PDF, DOC",
};

const FileUpload = ({ 
  attachments, 
  isUploading, 
  onFileUpload, 
  onRemoveFile 
}) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    onFileUpload(files);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);

    if (isUploading) return;

    const files = Array.from(e.dataTransfer.files);
    onFileUpload(files);
  };

  return (
    <div className="file-upload-container">
      <label className="file-upload-label">
        Attachments (Optional)
      </label>

      {/* Hidden File Input */}
      <input
        type="file"
        id="file-upload"
        multiple
        className="file-upload-input"
        onChange={handleFileChange}
        accept={FILE_UPLOAD_CONFIG.accept}
      />

      <div 
        className='file_input_box'
        onDragEnter={handleDragEnter}
        onDragLeave={handleDragLeave}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        <button
          type="button"
          className="file-upload-button"
          onClick={() => document.getElementById('file-upload').click()}
          disabled={isUploading}
        >
          <i className="fa-solid fa-paperclip"></i>
          <span>{isUploading ? 'Uploading...' : isDragging ? 'Drop files here' : 'Add files or screenshots'}</span>
        </button>

        {/* Show selected files inside the box */}
        {attachments.length > 0 && (
          <div className="file-upload-files-container">
            {attachments.map((file, index) => {
              const isImage = file.type.startsWith('image/');
              const url = isImage ? URL.createObjectURL(file) : null;

              return (
                <div
                  key={index}
                  className="file-upload-file-item"
                >
                  {isImage ? (
                    <img
                      src={url}
                      alt={file.name}
                      className="file-upload-image-preview"
                    />
                  ) : (
                    <span className="file-upload-file-name">
                      {file.name}
                    </span>
                  )}

                  {/* Cross Button at Top Right */}
                  <button
                    type="button"
                    onClick={() => onRemoveFile(index)}
                    className="file-upload-remove-btn"
                  >
                    ×
                  </button>
                </div>
              );
            })}
          </div>
        )}

        <p className="file-upload-help-text">
          Max file size: {FILE_UPLOAD_CONFIG.maxSize} • Supported: {FILE_UPLOAD_CONFIG.supportedFormats}
        </p>
      </div>
    </div>
  );
};

FileUpload.propTypes = {
  attachments: PropTypes.array.isRequired,
  isUploading: PropTypes.bool.isRequired,
  onFileUpload: PropTypes.func.isRequired,
  onRemoveFile: PropTypes.func.isRequired,
};

export default FileUpload;
